//=

const MotionVariants = {
  parse(initWith, animateTo, exitWith) {
    return {
      animate_to: animateTo,
      exit_with: exitWith,
      init_with: initWith,
    };
  },
};

// Exports
// -------

export default MotionVariants;
